import { toggleItems } from '@src/components/toggleItems';

document.addEventListener('DOMContentLoaded', function (event) {
  // ---- FAQ basic ----
  const faqBasic = $('.faq-section .basic-faq');
  faqBasic.each(function () {
    const $items = $(this).find('.toggle-item');
    toggleItems($items, true, true, true, true);
  });

  // ---- FAQ advanced ----

  const breakpoint = window.matchMedia('(min-width:768px)');
  const firstAccordionAdvanced = $('.faq-content-advanced').find('.item-0');

  // Remove light grey class from first element when opening the page
  firstAccordionAdvanced.find('.question').removeClass('md:text-grey-600');
  firstAccordionAdvanced.find('.question img').removeClass('md:opacity-60');
  firstAccordionAdvanced.find('.question').addClass('md:text-grey-400');

  // Check breakpoints changes to avoid weird behaviour on resize after toggle dropdowns
  // This is not normal user behaviour but just in case
  const breakpointCheckerOverview = (function () {
    if (breakpoint.matches === true) {
      $('.faq-content-advanced .content').addClass('hidden');
      firstAccordionAdvanced.next('.content').removeClass('hidden');
    } else {
      firstAccordionAdvanced.next('.content').removeClass('hidden');
      firstAccordionAdvanced.find('.question i').addClass('transform rotate-0');
    }
  })();
  breakpoint.addListener(breakpointCheckerOverview);

  // Toggle class to open or close dropdown
  const questionsAdvanced = $('.faq-content-advanced .question');
  questionsAdvanced.on('click', function () {
    const currentItem = $(this.closest('.item'));
    const currentItemId = currentItem[0].classList[currentItem[0].classList.length - 1];
    const itemsToShow = $('.faq-content-advanced').find(`.${currentItemId}`);
    // On Desktop for advanced FAQ, hide content that's not current one
    if (breakpoint.matches === true) {
      $('.faq-content-advanced .content').addClass('hidden');
      // Make all text and image light grey
      $('.faq-content-advanced .question').addClass('md:text-grey-600');
      $('.faq-content-advanced .question img').addClass('md:opacity-60');
      // Remove light grey from selected element and add dark grey
      currentItem.find('.question').addClass('md:text-grey-400');
      currentItem.find('.question').removeClass('md:text-grey-600');
      currentItem.find('.question img').removeClass('md:opacity-60');
    }
    itemsToShow.next('.content').toggleClass('hidden');
    itemsToShow.find('i').toggleClass('transform rotate-0');
  });
});
